// ActionScript file
// module input {
// 	import FenceRectangle = fence.FenceRectangle;
// 	import FenceTriangle = fence.FenceTriangle;

// 	import ModUnique = panel.ModUnique;
// 	import ModulProp = panel.ModulProp;

// 	import MountingSystem = mountsys.MountingSystem;
// 	import MountingType = mountsys.MountingType;

// 	import BattenDivision = roof.BattenDivision;
// 	import RoofShape = roof.RoofShape;
// 	import RoofType = roof.RoofType;
// 	import SC_Beam = roof.SC_Beam;

// 	import RoofHookInput = stocklist.roofhook.RoofHookInput;

import { ModulProp } from '../panel/ModulProp';
import { ModUnique } from '../panel/ModUnique';

import { MountingSystem } from '../mountsys/MountingSystem';
import { MountingType } from '../mountsys/MountingType';

import { RoofHookInput } from '../stocklist/roofhook/RoofHookInput';

import { Material } from '../utilities/Material';

// 	import SpotList = wr.SpotList;
import { RoofType } from '../roof/RoofType';
import { RoofShape } from '../roof/RoofShape';
import { SC_Beam } from '../roof/SC_Beam';
import { BattenDivision } from '../roof/BattenDivision';

import { ACOVPList } from '../input/ACOVPList';
import { TrapezParameter } from '../input/TrapezParameter';
import { PanelAutofillArea } from '../input/PanelAutofillArea';
import * as konva from '../konva/getCanvas';
import { InverterPlanGetData } from '../api/InverterPlanGet';
import { StaticsModel } from '../lib/StaticsModel';
import { ItemType } from '../lib/ItemType';
import { RoofPlanGetData } from '../api/RoofPlanGet';
import { PanelGetData } from '../api/PanelGet';

export class SC_Input {
    // Roof dimension in cm
    public static a: number;
    public static b: number;
    public static c: number;
    public static d: number;
    // roof colors for F, G, H areas
    static color = '#ce5e60'; // Roof H Area Color
    static colorF = '#a93335'; // Roof F Area Color
    static colorG = '#c53f42'; // Roof G Area Color
    static rectH: any = null;
    // Beam type
    public static iBeamType: number;
    // Beam spacing in cm
    public static nBeamDist: number;
    // Beam count
    public static iBeamAmount: number;
    // Distance from first edge to the first beam in cm
    public static nBeamDist1: number;
    // Distance from last edge to the last beam in cm
    public static nBeamDist2: number;
    // min max for beam distance
    public static beamMinMax: any = {
        nDistMin: null,
        nDistMax: null,
        nDistDefault: null,
    };

    // Roof shape
    public static iRoofShape: number;
    // Building height in cm
    public static iBuilding: number;
    public static verticalLengthCovered: number;
    public static horizontalLengthCovered: number;

    // Project details
    public static sProject: any = {};
    // Project name
    public static sName: string;
    // Current roof plan details
    public static sPlan: any;
    public static sPlanDetails: RoofPlanGetData = new RoofPlanGetData();
    // Flag plan altered
    public static isPlanAltered = false;
    // Current panel details
    public static sPanel: PanelGetData;
    public static userOwnPanelSelected: boolean;
    public static userSenPanelSelected: boolean;
    // Statics
    public static planStatics = new StaticsModel();

    // Roof plan item list
    public static roofPlanItems: ItemType[] = [];

    // Inverter plan data
    public static sInverter = new InverterPlanGetData();
    // Country ISO code lowercase
    public static sCountry: string = 'de';
    // Roof type
    public static iRoofType: number;

    // Roof pitch in degree
    public static iRoofAngle: number;
    // Terrain height in m
    public static iTerrain: number;
    // Flag is north German plain
    public static isNorthGermanPlain: boolean;

    public static nRoofRange: number;
    //Material
    public static iBeamMat: number;
    //Stockschraube
    public static sStosch: number;
    public static sStoschID: any;
    //Windzone
    public static sWindzone: string;
    //Schneezone
    public static sSchneezone: string;
    //Geländekategorie 0 = Kat 1, 1 = Kat 2...
    public static sTerrainCat: string;
    //Modul von SEN
    public static bModSEN: boolean;
    //Modulbreite in cm
    public static nModWidth: number;
    //Modulhöhe in cm
    public static nModHeight: number;
    //Moduldicke in cm
    public static nModThick: number;
    //Modulname
    public static sModulname: string;
    //project Modulname
    public static projectModulname: string;
    //Modul-ID
    public static sModulID: string;
    //Modul-Image
    public static sModulImg: string;
    //Modul-PDC
    public static sModulPdc: string;
    //Leistung in Wp
    public static nModLeistung: number;
    //Modul-Typ: mono = 1, poly = 2, duennschicht = 3
    public static iModType: number;
    //Modul-Anzahl
    public static iModulCount: number;
    //Modul-Ausrichtung
    public static iModAlignment: number;
    //Modul-Warengruppe
    public static sModWG: string;
    //mounting system
    public static iMountSys: number;
    //frame color
    public static iFrameColor: number;
    //batten division
    public static iBattenDivision: number;
    //mounting type
    public static iMountingType: number;
    //HGroups
    public static aHGroups: any[] = [];
    //Fences
    public static aFences: any[] = [];
    //Geladenes Projekt
    public static bLoadedProject: boolean;
    //roof orientation
    public static sRoofOrientation: string;
    // roof orientation deg
    public static sRoofOrientationDeg: number;

    //Wechselrichter Überdimensionierung min
    public static iWRFactMin: number;
    //Wechselrichter Überdimensionierung max
    public static iWRFactMax: number;
    //		//Wechselrichter Warengruppe
    //		public static var sInvWG:String;
    /**
     * Wechselrichter Belegungs-Array
     */
    public static acovplistCurrent: any; //ACOVPList;
    public static aInvAssign: any[];
    //no range
    public static bNoRange: boolean;
    //Träger für Bestigung
    public static bBeam: boolean;
    //Indach Anschlussklebeband Farbe
    public static sIDAnsKleBanCol: string;
    //Indach
    public static bInRoof: boolean;
    //Kragarm beachtet
    public static bKragarm: boolean;
    //Selbsterzeugung
    public static bOwnConsumption: boolean;
    //saved mod
    public static moduniqueCurrentMod: ModUnique;
    //roof hook
    public static roofhookinputCurrent: RoofHookInput;
    //trapez parameter
    public static trapezPara: TrapezParameter;
    //NS protection
    public static bNSProtect: boolean;
    //ripple control receiver
    public static bRCR: boolean;
    //default horizontal profile
    public static sHProfile: string;
    //panel autofill area
    public static iPnlFillArea: number;
    //profile length in cm
    public static iProfileLen: number;
    //trapezoidal sheet
    //high beading distance
    public static nHighBeadingDistance: number;
    //sheet thickness
    public static nTrapezSheetThickness: number;
    //material
    public static iTrapezMaterial: number;

    public static layerPanel: any = konva.getCanvasLayer();
    public static autoFillPanels = false;
    public static updatedBeamInput = false;

    public static profileCutList: any = [];

    // Reset input cache
    public static reset(): void {
        SC_Input.sName = '';
        SC_Input.sCountry = 'de';
        // SC_Input.sInverter = new InverterModel();
        SC_Input.iRoofType = RoofType.PANTILED;
        // Gable roof by default
        SC_Input.iRoofShape = RoofShape.SATTEL;
        SC_Input.iRoofAngle = 45;
        // SC_Input.iTerrain = 0;
        SC_Input.iBuilding = 7;
        SC_Input.isNorthGermanPlain = false;
        SC_Input.a = 1100;
        SC_Input.b = 2500;
        SC_Input.c = 1500;
        SC_Input.d = 300;
        SC_Input.iBeamType = SC_Beam.RAFTER;
        SC_Input.nBeamDist = 80;
        SC_Input.nBeamDist1 = 10;
        SC_Input.nBeamDist2 =
            (SC_Input.b - SC_Input.nBeamDist1) % SC_Input.nBeamDist;
        SC_Input.iBeamAmount =
            Math.floor(
                (SC_Input.b - (SC_Input.nBeamDist1 + SC_Input.nBeamDist2)) /
                    SC_Input.nBeamDist,
            ) + 1;
        SC_Input.iBeamMat = 0;
        SC_Input.sStosch = 0;
        SC_Input.userOwnPanelSelected = false;
        SC_Input.userSenPanelSelected = false;
        // SC_Input.sWindzone = "";
        // SC_Input.sSchneezone = "";
        // SC_Input.sTerrainCat = "";

        SC_Input.bModSEN = false;
        SC_Input.nModWidth = 0;
        SC_Input.nModHeight = 0;
        SC_Input.nModThick = 0;
        SC_Input.sModulname = '';
        SC_Input.sModulID = '';
        SC_Input.sModulImg = '';
        SC_Input.nModLeistung = 0;
        SC_Input.iModType = 0;
        // SC_Input.iModAlignment = ModulProp.ORIENTATION_HORIZONTAL;
        SC_Input.iModAlignment = ModulProp.ORIENTATION_VERTICAL;
        SC_Input.sModWG = '';

        SC_Input.iMountSys = MountingSystem.SOL50_STAN_2M;
        SC_Input.iBattenDivision = BattenDivision.NONE;
        SC_Input.iMountingType = MountingType.NONE;
        SC_Input.bLoadedProject = false;
        SC_Input.sRoofOrientation = 'S';
        SC_Input.sRoofOrientationDeg = 0;
        SC_Input.iWRFactMin = 100;
        SC_Input.iWRFactMax = 115;
        SC_Input.acovplistCurrent = new ACOVPList();
        SC_Input.aInvAssign = new Array();
        SC_Input.bNoRange = false;
        SC_Input.bBeam = false;
        SC_Input.sIDAnsKleBanCol = 'black';
        SC_Input.bInRoof = false;
        SC_Input.bKragarm = false;
        SC_Input.bOwnConsumption = false;
        SC_Input.bNSProtect = false;
        SC_Input.bRCR = false;
        SC_Input.moduniqueCurrentMod = new ModUnique('', false);
        SC_Input.roofhookinputCurrent = new RoofHookInput();
        SC_Input.trapezPara = new TrapezParameter();
        SC_Input.sHProfile = '';
        SC_Input.iPnlFillArea = PanelAutofillArea.INNER;
        SC_Input.iProfileLen = 0;
        //trapez sheet
        SC_Input.nHighBeadingDistance = 22.5;
        SC_Input.nTrapezSheetThickness = 1;
        SC_Input.iTrapezMaterial = Material.STEEL;
        SC_Input.roofPlanItems = [];

        SC_Input.profileCutList = [];
    }

    public static rememberFences(): void {
        //fence
        // var fenceTmp: FenceRectangle;
        // var fencetriangleTmp: FenceTriangle;
        // SC_Input.aFences = new Array();
        // for (var obj: Object in this.Global.pageDesign.canFence.getChildren()) {
        // 	if (obj instanceof FenceRectangle) {
        // 		fenceTmp = FenceRectangle(obj);
        // 		SC_Input.aFences.push(fenceTmp);
        // 	} else if (obj instanceof FenceTriangle) {
        // 		fencetriangleTmp = FenceTriangle(obj);
        // 		SC_Input.aFences.push(fencetriangleTmp);
        // 	}
        // }
    }

    public static clearRoof(): void {
        if (SC_Input.aHGroups.length > 0) {
            SC_Input.aHGroups = new Array();
        }
        if (SC_Input.aFences.length > 0) {
            SC_Input.aFences = new Array();
        }
    }

    public static noticeInvChange(): void {
        SC_Input.acovplistCurrent.removeAll();
        // SpotList.removeAll();
    }
}

// }
